module.exports = {
    // basic
    'requested-company': 'requested company',
    'requested-asset': 'requested asset',
    'requested-wellbores': 'requested wells',

    // raw
    // template
};
